import React, { Component, Fragment } from 'react' 

import Hero from '../../components/Hero'
import Breadcrumb from '../../components/Breadcrumb'
import EmployeeCTA from '../../components/EmployeeCTA'
import Question from '../../components/Question'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import { Container } from '../../styles/defaults'
import { MiniContainer } from './styles'

import hero from '../../assets/hero/bestellijst/bestellijst.jpg'
import employee from '../../assets/cta/employee.png'

class FAQ extends Component {
  constructor(props) {
    super(props)
    this.state = {
      questions: []
    }
  }

  // Sort invoices based on date
  componentDidMount() {
    const url = process.env.REACT_APP_HOST_ENV === 'production'
    ? 'https://kaarskoffie.nl'
    : process.env.REACT_APP_HOST_ENV === 'staging'
      ? 'https://kaarskoffie.nl'
      : 'https://kaarskoffie.nl'

    window.fetch(`${url}/wp-json/wp/v2/faq?per_page=99`).then((response) => {
      return response.json()
    }).then((r) => {
      this.setState({ questions: r })
    })
  }

  render() {
    return (
      <Fragment>
        <Hero setsize='small' small={hero} medium={hero} large={hero} retina={hero} title='Veelgestelde vragen' />
        <Breadcrumb title='Veelgestelde vragen' />
        <Container mb>
          <MiniContainer sm>
            {this.state.questions.map((question, index) => (
              <Question question={question} key={index} />
            ))}
          </MiniContainer>
          <MiniContainer full>
            <EmployeeCTA
              size={'medium'}
              content={{
                title: 'Staat uw vraag er niet tussen?',
                subtitle: 'We helpen u graag',
                employee: true,
                image: employee,
                link: {
                  content: 'Contact',
                  url: '/contact',
                  target: ''
                }
              }}
            />
          </MiniContainer>
        </Container>
      </Fragment>
    )
  }
}

export default withHeaderFooter(FAQ)



// WEBPACK FOOTER //
// ./src/views/FAQ/index.js